import shortid from 'shortid'
import Patient from '../../model/Patient'
import axios from 'axios'
import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import PatientsDiagnosisSimple from 'model/PatientsDiagnosisSimple'
import { searchPatientByNameSelectors } from '../../../src/patients/util/patient-name-util'

const formatPatientCode = (prefix: string, sequenceNumber: string) => `${prefix}${sequenceNumber}`

const getPatientCode = (): string => formatPatientCode('P-', shortid.generate())

const { server } = (window as any).config

export class PatientRepository extends WebRepository<Patient> {
  constructor() {
    super(new Api('patients'))
  }

  async search(text: string): Promise<Patient[]> {
    return super.search({
      selector: {
        $or: searchPatientByNameSelectors(text),
      },
      bookmark: '',
      limit: 10,
    })
  }

  async searchByQuery(query: any): Promise<Patient[]> {
    return axios.post(server + '/patients/searchByQuery', query)
  }
  async searchMainGroup(text: string): Promise<Patient[]> {
    return super.search({
      mainGroup: true,
      selector: {
        $or: searchPatientByNameSelectors(text),
      },
      bookmark: '',
      limit: 10,
    })
  }

  async searchInGroup(text: string, groupId: string): Promise<Patient[]> {
    return super.search({
      groupId,
      selector: {
        $or: searchPatientByNameSelectors(text),
      },
      bookmark: '',
      limit: 10,
    })
  }

  async generatePassword(): Promise<any> {
    return axios.get(server + '/generatePassword')
  }

  async getOxitoneId(email: String): Promise<any> {
    return axios.post(server + '/getOxitoneId', { email })
  }

  async requestExamination(
    name: String,
    type: String,
    patientId: String,
    appointmentId: String,
    executionTime?: String,
    orderselected?: String,
    orderSenderFreeText?: String,
    ignoreForDoctor?: boolean,
  ): Promise<any> {
    return axios.post(server + '/requestExamination', {
      name,
      type,
      patientId,
      appointmentId,
      executionTime,
      orderselected,
      orderSenderFreeText,
      ignoreForDoctor,
    })
  }

  async requestExaminationDiagnosis(
    name: String,
    type: String,
    patientId: String,
    patientDiagnoses: PatientsDiagnosisSimple[],
    executionTime?: String,
    orderselected?: String,
    orderSenderFreeText?: String,
    ignoreForDoctor?: boolean,
  ): Promise<any> {
    return axios.post(server + '/requestExaminationDiagnosis', {
      name,
      type,
      patientId,
      patientDiagnoses,
      executionTime,
      orderselected,
      orderSenderFreeText,
      ignoreForDoctor,
    })
  }

  async save(entity: Patient): Promise<Patient> {
    const patientCode = getPatientCode()
    entity.code = patientCode
    return super.save(entity)
  }
}

export default new PatientRepository()
